<template>
  <v-app :style="{ background: $vuetify.theme.themes[theme].background }">
    <v-progress-linear indeterminate v-if="isLoading" />
    <router-view v-else />
  </v-app>
</template>

<script>
import Vue from "vue"
import appMixin from "@/base_lib/data/mixins/appMixin"
import {mapGetters} from "vuex"
import createAxios from "@/base_lib/network/api"
import TeamService from "@/services/TeamService"
import router from "@/router";

export default {
  name: 'App',
  mixins: [appMixin],
  computed: {
    ...mapGetters({
      authenticated: 'auth/isLoggedIn',
      email: 'auth/email',
      editorId: 'auth/editorId',
    }),
    isSocketEnabled() {
      return process.env.VUE_APP_ENABLE_WEBSOCKET === 'true'
    },
  },
  data: () => ({
    isLoading: true,
  }),
  sockets: {
    connect: function () {
      console.log("Socket connected")
    },
    disconnect: function () {
      console.log("Socket disconnected")
    },
  },
  methods: {
    initializeApp() {
      // Menu is now dynamically rendered based on permissions from auth store
      // No need to save roles or pages to store/localStorage
      this.isLoading = false
      this.redirection()
    },
    fetchTeams() {
      if (this.authenticated && this.$store.getters['teams/allTeams'].length === 0) {
        console.log("Fetching teams")
        // TeamService.getTeams().then(response => {
        //   console.log("Teams", response.data.data)
        //   Vue.prototype.$stateManagement.dispatch('teams/setAllTeams', response.data.data)
        // })
      }
    },
    subscribeSocketChannel() {
      if (!this.isSocketEnabled) return
      console.log("[APP] -> Subscribe")
      this.sockets?.subscribe(this.socketChannel(), (data) => {
        console.log(`[APP] -> Subscribed qr-request-${this.editorId}`)
        console.log(`[APP]`, data)
      })
    },
    unsubscribeSocketChannel() {
      if (!this.isSocketEnabled) return
      console.log("[APP] -> Unsubscribe")
      this.sockets?.unsubscribe(this.socketChannel())
    },
    redirection() {
      // If currently on login page, always redirect to Welcome (successful login)
      if (this.$route.name === 'login') {
        router.push({ name: 'Welcome' })
        return
      }
      
      // If we have a query.from parameter (coming from login), handle redirect
      if (this.$route.query?.from) {
        if (this.$route.params.to) {
          router.push(this.$route.params?.to?.path)
        } else {
          router.push({ name: 'Welcome' })
        }
        return
      }
      
      // If at root path or home, redirect to Welcome
      if (this.$route.path === '/' || this.$route.name === 'home') {
        router.push({ name: 'Welcome' })
        return
      }
      
      // Otherwise, stay on the current route (for page refresh)
    }
  },
  watch: {
    authenticated: {
      immediate: true,
      handler(to) {
        if (to) {
          Vue.prototype.$http = createAxios()
          this.initializeApp()
          this.fetchTeams()
          if (this.isSocketEnabled) {
            this.$socket?.connect()
            this.subscribeSocketChannel()
          }
        } else {
          this.isLoading = false
          if (this.isSocketEnabled) {
            this.unsubscribeSocketChannel()
            this.$socket?.disconnect()
          }
        }
      }
    },
    $route: {
      immediate: true,
      handler(to) {
        if (!!window.ATL_JQ_PAGE_PROPS && !!window.ATL_JQ_PAGE_PROPS.fieldValues) {
          window.ATL_JQ_PAGE_PROPS.fieldValues.description = `... is not working correctly. \n\n\nName: ${this.fullName}\nEmail: ${this.email}\nPage: ${to.meta.title ?? ""}\nURL: ${window.location.href}.\nUser Agent: ${navigator.userAgent}.\nScreen Resolution: ${screen.width}x${screen.height}`
        }
      },
    },
  },
}
</script>
